import { PHONE_DATA } from 'app/design-system/components/PhoneInput/constants';

import useCurrentRegion from './useCurrentRegion';

const usePhoneData = () => {
  const currentRegion = useCurrentRegion();
  if (!isSupportedRegion(currentRegion)) {
    return PHONE_DATA.default;
  }

  return PHONE_DATA[currentRegion];
};

export default usePhoneData;

export function isSupportedRegion(region?: string): region is keyof typeof PHONE_DATA {
  return typeof region === 'string' && region in PHONE_DATA;
}
